import { toLunar, toSolar, fromJulianDay, LunarTable, SolarTable, LunarData, SolarData, LunarDate, SolarDate } from "./kor-lunar";
import { LunarCalendar } from "./lunar-calendar";

const korLunar = { toLunar, toSolar, fromJulianDay, LunarTable, SolarTable, LunarData, SolarData, LunarCalendar };
export default korLunar;
export { toLunar, toSolar, fromJulianDay, LunarTable, SolarTable, LunarData, SolarData, LunarDate, SolarDate, LunarCalendar };
